module.exports = __webpack_public_path__ + "img/graphIcon_Active.299ca97f.png";